import SmoothScroll from 'smooth-scroll'
import Navigation from './lib/navigation'
import stickyContent from './lib/stickyContent'
import Accordion from './lib/accordion'
import Splide from '@splidejs/splide'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if(toggle.href == '#'){
      return 0
    }else{
      const headerHeight = document.querySelector('.header') ?
        document.querySelector('.header').offsetHeight : 0;
      return headerHeight
    }
  }
})

Navigation('header-nav__btn', 'body')
Accordion()

stickyContent([['scroll-top', 'footer']])

// slider -------------------------------------------------

const options = {
  mediaQuery: 'min',
  perMove: 1,
  perPage: 1,
  gap: "1.25rem",
  focus: "center",
  easing: 'linear',
  drag: true,
  arrows: true,
  pagination: true,
  breakpoints: {
    768: {
      perMove: 2,
      perPage: 2,
    },
  },
}
if(document.getElementById('banners')) {
  new Splide( '#banners', options ).mount()
}
if(document.getElementById('topBanners')) {
  new Splide( '#topBanners', options ).mount()
}
if(document.getElementById('topMain')) {
  const options = {
    type: 'fade',
    arrows: false,
    pagination: true,
    perMove: 1,
    perPage: 1,
    focus: "center",
    easing: 'linear',
    drag: true,
    autoplay: true,
    interval: 5000,
    rewind: true
  }
  new Splide( '#topMain', options ).mount()
}


// toc -------------------------------------------------

if(document.getElementById('toc')) {
  const createColumn = (link, text) => {
    const el_wrap = document.createElement('li')
    const el_inner = document.createElement('a')
    el_inner.href = link
    el_inner.textContent = text
    el_wrap.appendChild(el_inner)
    return el_wrap
  }
  const toc_content = document.querySelector('.toc-content')
  const toc_list =  document.querySelector('.toc-list')
  const h2 = toc_content.querySelectorAll('h2')
  h2.forEach((el) => {
    el.id = el.textContent
    const hash = `#${el.textContent}`
    const column = createColumn(hash, el.textContent)
    toc_list.appendChild(column)
  })
}

// dropdown-text -------------------------------------------------

if(document.querySelector('.dropdown-text')) {
  const dropdown_container = document.querySelectorAll('.dropdown-text')
  dropdown_container.forEach((el) => {
    if(el.classList.contains('--has-after')) {
      const dropdown_button = el.querySelector('.dropdown-text__more')
      dropdown_button.addEventListener('click', ()=> {
        el.classList.toggle('--dropdown-on')
      })
    }
  })
}
